module.exports = __webpack_public_path__ + "img/festival-600x450.86e8dae6.jpg";